import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertCircle, FiArrowRight } = FiIcons;

const PasswordGate = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const CORRECT_PASSWORD = 'Padua4467';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      sessionStorage.setItem('padua_auth', 'true');
      onAuthenticated(true);
    } else {
      setError(true);
      setPassword('');
    }
  };

  return (
    <div className="min-h-screen bg-[#FCFAF6] flex items-center justify-center p-6 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#F6F1E8] rounded-full blur-[120px] -z-10 opacity-60"></div>
      
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-white border border-[#D9CCBA]/40 rounded-3xl p-8 md:p-12 shadow-xl shadow-[#D9CCBA]/10"
      >
        <div className="text-center mb-10">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/8c3dc8994f71a85ad2d71f226c89cc7edce114857865647a461869cb9a6c120ffe2f6c628544606d61dcf48135de6ac8/images/aW1hZ2UvcG5n/982cd76f140479f64830f15898823d30.png" 
            alt="Padua Weddings Logo" 
            className="w-[100px] md:w-[130px] mx-auto mb-6 object-contain"
          />
          <h1 className="text-3xl font-serif text-[#2F2B28] mb-3">Internal Review Hub</h1>
          <p className="text-[#2F2B28]/60 font-light">Authorized team access only</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (error) setError(false);
              }}
              placeholder="Enter Access Key"
              className={`w-full bg-[#FCFAF6] border ${error ? 'border-red-300 focus:ring-red-100' : 'border-[#D9CCBA]/60 focus:ring-[#D9CCBA]/30'} rounded-xl px-5 py-4 text-center text-lg outline-none focus:ring-4 transition-all duration-300 placeholder:text-[#2F2B28]/30`}
              autoFocus
            />
          </div>

          <button
            type="submit"
            className="w-full bg-[#2F2B28] text-[#FCFAF6] font-medium py-4 rounded-xl flex items-center justify-center space-x-2 hover:bg-[#6E7451] transition-colors duration-300 group"
          >
            <span>Enter Dashboard</span>
            <SafeIcon icon={FiArrowRight} className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" />
          </button>
        </form>

        <AnimatePresence>
          {error && (
            <motion.div 
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="mt-8 p-4 bg-red-50 border border-red-100 rounded-xl flex items-start space-x-3"
            >
              <SafeIcon icon={FiAlertCircle} className="w-5 h-5 text-red-500 shrink-0 mt-0.5" />
              <p className="text-sm text-red-700 leading-relaxed font-medium">
                Incorrect password. Please contact the Padua Weddings marketing team if you need access.
              </p>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="mt-12 pt-8 border-t border-[#D9CCBA]/20 text-center">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#A67C52] font-semibold">
            Padua Weddings & Events
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default PasswordGate;